import * as React from 'react';

export const MagnifyingGlassIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 490 490"
		preserveAspectRatio="xMidYMid meet"
		width={props.width}
		{...props}
	>
		<path
			fill="none"
			strokeWidth="2rem"
			strokeLinecap="round"
			d="m280,278a153,153 0 1,0-2,2l170,170m-91-117 110,110-26,26-110-110"
		/>
	</svg>
);
